import { useRef, useState } from 'react'
import { useIsomorphicLayoutEffect, useInView, animate } from 'motion/react'

export const AnimatedNumber = ({from, to, fontSize}:{from: number, to: number, fontSize: string}) => {

    const [animatedNumber, setAnimatedNumber] = useState(from)
    const ref = useRef(null)
    const inView = useInView(ref, { once: true });
    
    useIsomorphicLayoutEffect(() => {
        const element = ref.current;

        if (!element) return;
        if (!inView) return;

        //Set initial value
        setAnimatedNumber(from)

        // If reduced motion is enabled in system's preferences
        if (window.matchMedia("(prefers-reduced-motion)").matches) {
        setAnimatedNumber(to);
        return;
        }

        const controls = animate(from, to, {
        duration: 2,
        ease: "easeOut",
        onUpdate(value) {
           setAnimatedNumber ( Number(value.toFixed(0)));
            
        },
        });

        // Cancel on unmount
        return () => {
        controls.stop();
        };
    }, [ref, inView, from, to]);

    return(
        <span style={{color: 'white', fontSize: fontSize, fontFamily:'monospace'}} ref={ref}>{animatedNumber}</span>
    )
}
